import { UPDATE_PEDIDOS } from '../actionTypes';

export const updatePedidos = (payload) => ({
	type: UPDATE_PEDIDOS,
	payload,
});
